import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { TypingState } from '@sda/interfaces/thread/typingstate';
import type { FetchDataType } from '@sda/sdk/interfaces';

// LISTENERS

export const startFetchTypingStates = createAction<string>(`${Reducers.TYPING_STATES}/startFetchTypingStates`);
export const unsubscribeTypingStates = createAction<string>(`${Reducers.TYPING_STATES}/unsubscribeTypingStates`);

export const startSetTypingState = createAction(`${Reducers.TYPING_STATES}/startSetTypingState`);

export const typingStateAdapter = createEntityAdapter<TypingState & FetchDataType>();

const typingStatesSlice = createSlice({
  initialState: typingStateAdapter.getInitialState(),
  name: Reducers.TYPING_STATES,
  reducers: {
    ...extractSharedActions(typingStateAdapter),
  },
});

export default typingStatesSlice.reducer;
